// extracted by mini-css-extract-plugin
module.exports = {"listItem":"PricePageModalItem_listItem__URvOK","button":"PricePageModalItem_button__Ktxa4"};